module.exports = __webpack_public_path__ + "static/media/gb-nir.a95d922e.svg";